//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getIsBazaarvoiceNetworkGallerySelected } from '@galleries/selectors/getIsBazaarvoiceNetworkGallerySelected';
import { getSelectedGallery } from '@galleries/selectors/getSelectedGallery';
import { ICuralateStore } from '@models/AppState';

export const VISUAL_SYNDICATION_NETWORK = 'Visual Syndication Network';

export const getSelectedGalleryName = createSelector(
  (state: ICuralateStore) => getSelectedGallery(state),
  (state: ICuralateStore) => getIsBazaarvoiceNetworkGallerySelected(state),
  (selectedGallery, isBazaarvoiceNetworkGallerySelected) => {
    if (isBazaarvoiceNetworkGallerySelected) {
      return VISUAL_SYNDICATION_NETWORK;
    } else {
      return selectedGallery?.displayName ?? '';
    }
  },
);
